import React from "react";
import { TaskItemProps } from "../task-item";
import styles from "./milestone.module.css";

export const Milestone: React.FC<TaskItemProps> = ({
  task,
  isDateChangeable,
  onEventStart,
  isSelected,
}) => {
  const transform = `rotate(45 ${task.x1 + task.height * 0.356} 
    ${task.y + task.height * 0.85})`;
  const getBarColor = () => {
    return isSelected
      ? task.styles.backgroundSelectedColor
      : task.styles.backgroundColor;
  };

  const shouldShowMilestone = task.id.endsWith("-act") || (!task.id.endsWith("-recalc") && (!task.id.endsWith("-est") || !task.baseLineTask?.length));

  if (!shouldShowMilestone) return null;

  return (
    <g tabIndex={0} className={styles.milestoneWrapper} data-taskid={task.id} data-type="Task">
      <rect
        data-type="Task" data-taskid={task.id}
        fill={getBarColor()}
        x={task.x1}
        width={task.height}
        y={task.y}
        height={task.height}
        rx={task.barCornerRadius}
        ry={task.barCornerRadius}
        transform={transform}
        className={styles.milestoneBackground}
         onMouseDown={e => {
          isDateChangeable &&  onEventStart(e.button == 0 ? "move":"", task, e);
        }}
      />
      {window.location.pathname.includes("projects") && (
        <text
          x={task.x1 + task.height / 2}
          y={task.y + task.height + 15}
          textAnchor="middle"
          fontSize="10"
          fontWeight="600"
          fill="#1e293b"
          className="select-none pointer-events-none"
          style={{
            paintOrder: 'stroke',
            stroke: '#fff',
            strokeWidth: '3px',
            strokeLinejoin: 'round',
          }}
        >
          {task.name}
        </text>
      )}
    </g>
  );
};
